<template>
    <div>
        <v-card>
            <v-toolbar color="red" dark>
                <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            </v-toolbar>
            <v-form id="createForm" @keyup.enter.native="onSave">
                <v-layout wrap>
                    <v-flex xs12 v-for="item in inputItems" style="padding: 10px">
                        <c-textbox :type="item.type" :icon="item.icon" :validate="item.validate" :label="$t(item.label)+'*'"
                                   :id="item.id" :name="item.name" :value="values[item.name]"
                                   v-model.trim="values[item.name]"
                                   :placeholder="$t(item.placeHolder)" :max-length="item.maxlength" :autofocus="item.focus"
                                   ref="input"></c-textbox>

                    </v-flex>
                </v-layout>
                <v-layout wrap style="padding: 10px;" id="designPanel">
                    <v-flex id="canvasDiv" class="xs8 md8 x8" style="position: relative; background-color: white">
                        <div id="canvas" style="height: 600px;padding: 0;margin: 0;border: 1px solid gray;"></div>
                        <div style="position: absolute;left:0px;bottom:0px">
                            <v-btn color="cyan" fab small icon dark @click="onZoomFit" style="float:left">
                                <v-icon dark>open_with</v-icon>
                            </v-btn>
                            <v-btn color="light-blue" fab small icon dark @click="onZoomIn" style="float:left">
                                <v-icon dark>zoom_in</v-icon>
                            </v-btn>
                            <v-btn color="orange" fab small icon dark @click="onZoomOut" style="float:left">
                                <v-icon dark>zoom_out</v-icon>
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex id="propertyDiv" class="xs4 md4 x4">
                        <div class="properties-panel-parent"
                             id="js-properties-panel"></div>
                    </v-flex>
                </v-layout>
            </v-form>
            <div style="text-align: right">

                <v-btn color="blue-grey" dark @click="onHideProperties">
                    <v-icon dark left>{{showHideIcon}}</v-icon>
                    {{showHideProperty}}
                </v-btn>
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{$t('lang.common.save')}}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{$t('lang.common.cancel')}}
                </v-btn>
            </div>
        </v-card>

        <v-dialog v-model="propertyDialog" width="800px" height="auto">
            <v-card>
                <v-toolbar color="red" dark>
                    <v-toolbar-title>{{$t('lang.workflow.edit_property')}}</v-toolbar-title>
                </v-toolbar>
                <form id="editPropertiesForm">
                    <div id="tableDiv" style="display: none;">
                        <table id="propertiesTable" class="viewTable"></table>
                        <div style="text-align: right">
                            <v-btn color="primary" onClick="onAddItem();" text="Add"/>
                        </div>
                    </div>
                    <div id="propertiesForm" style="padding-left:10px;padding-right: 10px"></div>
                </form>
                <div style="text-align: right">
                    <v-btn color="primary" @click="onSaveProperties">
                        <v-icon dark left>save</v-icon>
                        {{$t('lang.common.save')}}
                    </v-btn>
                    <v-btn color="error" @click="onCloseDialog">
                        <v-icon dark left>cancel</v-icon>
                        {{$t('lang.common.cancel')}}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="childPropertyDialog" width="800px" height="auto">
            <v-card>
                <v-toolbar color="red" dark>
                    <v-toolbar-title>{{$t('lang.workflow.edit_property')}}</v-toolbar-title>
                </v-toolbar>
                <form id="editPropertiesForm">
                    <div id="tableDiv" style="display: none;">
                        <table id="childPropertiesTable" class="viewTable"></table>
                        <div style="text-align: right">
                            <v-btn color="primary" onClick="onAddItem();" text="Add"/>
                        </div>
                    </div>
                    <div id="childPropertiesForm" style="padding-left:10px;padding-right: 10px"></div>
                </form>
                <div style="text-align: right">
                    <v-btn v-if="this.$store.state.auth.accessLevel == 2" color="primary" @click="onSaveChildProperties">
                        <v-icon dark left>save</v-icon>
                        {{$t('lang.common.save')}}
                    </v-btn>
                    <v-btn color="error" @click="onCloseChildDialog">
                        <v-icon dark left>cancel</v-icon>
                        {{$t('lang.common.cancel')}}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
        <i-select-data v-on:onselect="onSelectData" v-on:onclose="onCloseDataDlg"></i-select-data>

    </div>
</template>

<script>
    import CTextbox from "../../../components/form/Textbox";
    import Validator from "../../../../public/js/validator";
    import Bpmn from "../../../../public/plugin/bpmn/bpmn";

    //console.log(Bpmn);
    import axios from "axios/index";

    import BpmnModeler from 'bpmn-js/lib/Modeler';
    import style from 'bpmn-js/dist/assets/diagram-js.css'; // eslint-disable-line no-unused-vars
    import icons from 'bpmn-font/dist/css/bpmn-embedded.css'; // eslint-disable-line no-unused-vars
    import bpmncss from '../../../../public/plugin/bpmn/bpmn.css';
    import ISelectData from "../../../components/form/SelectData";
    import VueController from "../../../../public/js/controller"; // eslint-disable-line no-unused-vars
    import {message} from "@/shared/message";

    const v = Validator();
    ////console.log("---v---");
    ////console.log(v);

    export default {
        name: 'procedure-create',
        components: {ISelectData, CTextbox, Validator},
        inheritAttrs: true,
        props: {
            formName: {
                type: String,
                default: 'Manager'
            },
            inputItems: {
                type: Array,
                default: () => []
            },
            createUrl: {
                type: String,
                default: ""
            },
            column: {
                type: String,
                default: "12"
            },
            defaultData: {
                type: Object,
                default: ()=>{}
            }
        },
        data: () => {
            return {
                values: {},
                selectData: {},
                propertyDialog: false,
                childPropertyDialog:false,
                selectPropertyFromDB: false,
                showHideProperty:"",
                showHideIcon:"",
                zoomlevel:1,
                copy:false
            }
        },
        watch: {
            defaultData: function (value) {
                ////console.log("watch default data");
                this.values = value;
                let formConfig = value["formConfig"];//FormGenerator.decodeHTML(value["formConfig"]);
                //console.log(formConfig);
            },

            propertyDialog: function (value) {
                //console.log("---hide or show ---");
                //this.propertyDialog = value;
                if (value == false) {
                    Bpmn.modelingConfig.editingStack.pop();
                    //console.log(Bpmn.modelingConfig.editingStack);
                }
            },
            childPropertyDialog: function (value) {
                //console.log("---hide or show ---");
                //this.propertyDialog = value;
                if (value == false) {
                    Bpmn.modelingConfig.editingStack.pop();
                    //console.log(Bpmn.modelingConfig.editingStack);
                }
            }
        },
        mounted() {
            Bpmn.initBPMNM();
            Bpmn.element = this;
            this.showHideProperty = this.$t('lang.workflow.hide_property');
            this.showHideIcon="keyboard_tab";
        },
        methods: {
            save: function (xml) {
                this.values["flowConfig"] = xml;
                let validate = v.validate(this);
                if (validate) {
                    axios.post(process.env.VUE_APP_API_URL + this.createUrl, this.values).then(data => {
                        if (data.success) {
                            if(this.values["workflowId"] != undefined) {
                                message.success(this.$t("lang.common.update_success"));
                            } else {
                                message.success(this.$t("lang.common.save_success"));
                            }
                            this.onCancel();
                        } else {
                            message.error(data.description);
                        }
                    }, error => {
                        message.error(error);
                    });
                } else {
                    message.error(this.$t("lang.common.validate_fail"));
                }
            },

            onSave: function () {
                Bpmn.saveDiagram(this.save);
            },

            onView: function (value) {
                this.values = value;
                Bpmn.initDiagram(this.values["flowConfig"]);
                this.$refs.input[0].focus();
            },

            loadData: function (sql,valueField,value,multiSelect) {
                let dlg = VueController.getComponentByComponentName("i-select-data");
                dlg.loadData(sql,valueField,value,multiSelect);
            },

            onSelectData: function(value){
                //console.log(value);
                Bpmn.updatePropertyFromDlg(value);
            },

            onCancel: function () {
                this.values = {};
                document.getElementById("searchDiv").style.display = "";
                document.getElementById("createDiv").style.display = "none";
                this.$parent.search();
            },

            onCloseDialog: function () {
                this.propertyDialog = false;
            },

            onCloseChildDialog: function () {
                this.childPropertyDialog = false;
            },

            onSaveProperties: function () {
                Bpmn.onSaveProperties();
            },

            onSaveChildProperties: function(){
                Bpmn.onSaveChildProperties();

            },

            onCloseDataDlg: function(){
                //
                //
                //
                //console.log("close data dlg");
                Bpmn.modelingConfig.editingStack.pop();
                //console.log(Bpmn.modelingConfig.editingStack);
            },

            onHideProperties: function(){
                if(document.getElementById("propertyDiv").style.display == "none") {
                    document.getElementById("propertyDiv").style.display = "";
                    document.getElementById("canvasDiv").setAttribute("class", "flex xs8 sm8 md8 lg8 xl8");
                    this.showHideProperty = this.$t('lang.workflow.hide_property');
                    this.showHideIcon= "keyboard_tab";
                } else {
                    document.getElementById("propertyDiv").style.display = "none";
                    document.getElementById("canvasDiv").setAttribute("class", "flex xs12 sm8 md12 lg12 xl12");
                    this.showHideProperty = this.$t('lang.workflow.show_property');
                    this.showHideIcon= "keyboard_backspace";
                }
            },

            goInFullscreen(element) {
                if(element.requestFullscreen)
                    element.requestFullscreen();
                else if(element.mozRequestFullScreen)
                    element.mozRequestFullScreen();
                else if(element.webkitRequestFullscreen)
                    element.webkitRequestFullscreen();
                else if(element.msRequestFullscreen)
                    element.msRequestFullscreen();
            },

            onZoomIn:function(){
                if(this.zoomlevel < 1){
                    this.zoomlevel +=0.1;
                } else if(this.zoomlevel < 10){
                    this.zoomlevel +=0.1;
                }
                let canvas = Bpmn.bpmnModeler.get('canvas');
                canvas.zoom(this.zoomlevel);
            },

            onZoomOut:function(){
                if(this.zoomlevel>1){
                    this.zoomlevel-=0.1;
                } else if(this.zoomlevel > 0.1){
                    this.zoomlevel-=0.1;
                }
                let canvas = Bpmn.bpmnModeler.get('canvas');
                canvas.zoom(this.zoomlevel);

            },

            onZoomFit: function(){
                let canvas = Bpmn.bpmnModeler.get('canvas');
                canvas.zoom('fit-viewport');
                this.zoomlevel = 1;
/*
                let div = document.getElementById("designPanel");
                this.goInFullscreen(div);
*/

            }
        }


    }
</script>
